/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
  GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams,
  GetApiV1CourseregistrationSharedSubStatusReasonList401,
  GetApiV1CourseregistrationSharedSubStatusReasonList500,
} from "../../types/courseRegistrationSharedController/GetApiV1CourseregistrationSharedSubStatusReasonList.ts";

function getGetApiV1CourseregistrationSharedSubStatusReasonListUrl() {
  const res = {
    method: "GET",
    url: `/api/v1/courseregistration/shared/sub-status-reason-list` as const,
  };
  return res;
}

/**
 * @description Retorna os submotivos de status ativos vinculados ao motivo de status informado, ordenados alfabeticamente pelo nome. **(Requer Authorization para autenticação)**
 * @summary Retorna a lista de submotivos de status para dropdown (Requer Authorization para autenticação)
 * {@link /api/v1/courseregistration/shared/sub-status-reason-list}
 */
export async function getApiV1CourseregistrationSharedSubStatusReasonList(
  params?: GetApiV1CourseregistrationSharedSubStatusReasonListQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1CourseregistrationSharedSubStatusReasonListQueryResponse,
    ResponseErrorConfig<
      | GetApiV1CourseregistrationSharedSubStatusReasonList401
      | GetApiV1CourseregistrationSharedSubStatusReasonList500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1CourseregistrationSharedSubStatusReasonListUrl().url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
